/* eslint-disable */
const LangIdleMonitor = {
	"idleMonitor.warnMessage": [
		"You will be logged out automatically in ${time} minutes.",
		"Bạn sẽ tự động đăng xuất sau ${time} phút.",
	],
	"idleMonitor.sessionExpired": [
		"Your session was expired.",
		"Phiên hoạt động của bạn đã hết hạn.",
	],
}

export default LangIdleMonitor



// WEBPACK FOOTER //
// ./src/resources/modules/LangIdleMonitor.js